import React from 'react';

const IconHamburger = () => {
	return (
		<svg aria-hidden="true" width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M8 10L6.93517 10L6.93517 -3.03146e-07L8 -3.49691e-07L8 10ZM4.53241 10L3.46759 10L3.46759 -1.51573e-07L4.53241 -1.98118e-07L4.53241 10ZM1.06483 10L0 10L-4.37114e-07 0L1.06483 -4.65453e-08L1.06483 10Z" fill="#545454"/>
		</svg>
	);
};

export default IconHamburger;
